import React from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Users, BookOpen, Globe, Layers, Smartphone, Briefcase, Sparkles, Check, ArrowRight } from "lucide-react";

const ICONS = { users: Users, "book-open": BookOpen, globe: Globe, layers: Layers, smartphone: Smartphone, briefcase: Briefcase, code: Sparkles };

export default function Services() {
  const [services, setServices] = React.useState([]);
  React.useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="hero-mesh grain">
        <div className="container-wide py-20 md:py-28">
          <div className="overline">What we do</div>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-4xl">Services designed to move enterprise IT forward.</h1>
          <p className="mt-6 max-w-2xl text-[color:var(--sky-muted)] text-lg leading-relaxed">
            From bespoke CRM and LMS platforms to full IT staffing — every engagement is delivered by senior
            engineers, priced transparently, and shipped on schedule.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-wide grid gap-8 lg:grid-cols-2">
          {services.map((sv, i) => {
            const Icon = ICONS[sv.icon] || Sparkles;
            return (
              <div key={sv.id} className="card-flat p-8">
                <div className="flex items-start gap-5">
                  <div className="shrink-0 w-12 h-12 rounded-md bg-[color:var(--sky-navy)] text-white inline-flex items-center justify-center">
                    <Icon size={22} />
                  </div>
                  <div className="flex-1">
                    <div className="font-mono-plex text-[11px] text-[color:var(--sky-muted)]">SERVICE {String(i+1).padStart(2, '0')}</div>
                    <h3 className="mt-1 font-display font-bold text-2xl tracking-tight">{sv.title}</h3>
                    <p className="mt-1 text-[color:var(--sky-navy)] text-sm font-medium">{sv.tagline}</p>
                    <p className="mt-4 text-sm text-[color:var(--sky-muted)] leading-relaxed">{sv.description}</p>

                    {sv.features && sv.features.length > 0 && (
                      <ul className="mt-5 grid gap-2 sm:grid-cols-2">
                        {sv.features.map((f) => (
                          <li key={f} className="flex items-start gap-2 text-sm">
                            <Check size={14} className="mt-0.5 text-[color:var(--sky-cyan)]" />
                            <span>{f}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="section bg-white border-y border-[color:var(--sky-border)]">
        <div className="container-wide flex flex-wrap items-center gap-6 justify-between">
          <div>
            <div className="overline">Ready to start?</div>
            <h2 className="mt-3 font-display font-bold text-3xl md:text-4xl tracking-tight max-w-2xl">Tell us about your project or staffing brief.</h2>
          </div>
          <Link to="/contact" className="btn-primary">Talk to us <ArrowRight size={16} /></Link>
        </div>
      </section>
    </div>
  );
}
